module.exports = __webpack_public_path__ + "img/gaingels.bcd33172.png";